import axios from "axios";
import commonLocations, { GeocodingResult } from "../data/commonLocations";

export const geocodeLocation = async (
  locationName: string
): Promise<GeocodingResult | null> => {
  try {
    // 1. First check our local database of common locations
    const normalizedName = locationName.toLowerCase().trim().split(",")[0];

    if (commonLocations[normalizedName]) {
      return commonLocations[normalizedName];
    }

    // 2. If not found locally, use Nominatim (OpenStreetMap) API as fallback
    // This is free but has usage policy - ensure to follow their usage policy:
    // https://operations.osmfoundation.org/policies/nominatim/
    const response = await axios.get(
      `https://nominatim.openstreetmap.org/search`,
      {
        params: {
          q: locationName,
          format: "json",
          limit: 1,
        }
      }
    );

    if (response.data && response.data.length > 0) {
      const result = response.data[0];
      return {
        lat: parseFloat(result.lat),
        lng: parseFloat(result.lon),
      };
    }

    return null;
  } catch (error) {
    console.error("Eroare la geocoding locație:", error);
    return null;
  }
};

export interface GeocodingSuggestion {
  display_name: string;
  lat: number;
  lng: number;
}

/**
 * Fetch multiple geocoding suggestions for a location using Nominatim API
 */
export const geocodeLocationSuggestions = async (
  locationName: string
): Promise<GeocodingSuggestion[]> => {
  try {
    const response = await axios.get(
      `https://nominatim.openstreetmap.org/search`,
      {
        params: {
          q: locationName,
          format: "json",
          limit: 5,
        }
      }
    );
    if (response.data && Array.isArray(response.data)) {
      return response.data.map((result: any) => ({
        display_name: result.display_name,
        lat: parseFloat(result.lat),
        lng: parseFloat(result.lon),
      }));
    }
    return [];
  } catch (error) {
    console.error("Error fetching geocoding suggestions:", error);
    return [];
  }
};
